import { render, staticRenderFns } from "./DealClientSummary.vue?vue&type=template&id=6d6d9d3e"
import script from "./DealClientSummary.vue?vue&type=script&lang=js"
export * from "./DealClientSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports